// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fichas-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
}

.fichas-table th,
.fichas-table td {
    border: 1px solid #e2e8f0;
    padding: 10px;
    text-align: left;
    font-size: 14px;
}

.fichas-table th {
    background: #edf2f7;
    color: #4a5568;
}

.fichas-table tr:nth-child(even) {
    background: #fcfdfd;
}

.ficha-detalhe-view {
    background: #f8fafc;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    margin-top: 15px;
}

.ficha-detalhe-view h3 {
    margin-top: 0;
    color: #2b6cb0;
}

.ficha-respostas-sec {
    margin-top: 20px;
}

.ficha-respostas-sec h4 {
    margin-bottom: 10px;
    border-bottom: 1px solid #cbd5e1;
    padding-bottom: 5px;
    color: #1a202c;
}

.ficha-res-table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
}

.ficha-res-table td {
    padding: 8px;
    border-bottom: 1px dashed #cbd5e1;
}

.ficha-res-table tr:last-child td {
    border-bottom: none;
}

.badge-s {
    display: inline-block;
    background: #10b981;
    color: white;
    padding: 3px 8px;
    border-radius: 4px;
    font-weight: bold;
    font-size: 12px;
}

.badge-n {
    display: inline-block;
    background: #ef4444;
    color: white;
    padding: 3px 8px;
    border-radius: 4px;
    font-weight: bold;
    font-size: 12px;
}

.ficha-fotos {
    margin-top: 30px;
}

.ficha-fotos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 15px;
}

.ficha-fotos-grid img {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;
}

.ficha-fotos-grid img:hover {
    transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./src/components/FichasLevantamentoLista.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".fichas-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 15px;\r\n}\r\n\r\n.fichas-table th,\r\n.fichas-table td {\r\n    border: 1px solid #e2e8f0;\r\n    padding: 10px;\r\n    text-align: left;\r\n    font-size: 14px;\r\n}\r\n\r\n.fichas-table th {\r\n    background: #edf2f7;\r\n    color: #4a5568;\r\n}\r\n\r\n.fichas-table tr:nth-child(even) {\r\n    background: #fcfdfd;\r\n}\r\n\r\n.ficha-detalhe-view {\r\n    background: #f8fafc;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    border: 1px solid #e2e8f0;\r\n    margin-top: 15px;\r\n}\r\n\r\n.ficha-detalhe-view h3 {\r\n    margin-top: 0;\r\n    color: #2b6cb0;\r\n}\r\n\r\n.ficha-respostas-sec {\r\n    margin-top: 20px;\r\n}\r\n\r\n.ficha-respostas-sec h4 {\r\n    margin-bottom: 10px;\r\n    border-bottom: 1px solid #cbd5e1;\r\n    padding-bottom: 5px;\r\n    color: #1a202c;\r\n}\r\n\r\n.ficha-res-table {\r\n    width: 100%;\r\n    table-layout: fixed;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.ficha-res-table td {\r\n    padding: 8px;\r\n    border-bottom: 1px dashed #cbd5e1;\r\n}\r\n\r\n.ficha-res-table tr:last-child td {\r\n    border-bottom: none;\r\n}\r\n\r\n.badge-s {\r\n    display: inline-block;\r\n    background: #10b981;\r\n    color: white;\r\n    padding: 3px 8px;\r\n    border-radius: 4px;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n}\r\n\r\n.badge-n {\r\n    display: inline-block;\r\n    background: #ef4444;\r\n    color: white;\r\n    padding: 3px 8px;\r\n    border-radius: 4px;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n}\r\n\r\n.ficha-fotos {\r\n    margin-top: 30px;\r\n}\r\n\r\n.ficha-fotos-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n    gap: 15px;\r\n}\r\n\r\n.ficha-fotos-grid img {\r\n    width: 100%;\r\n    height: 150px;\r\n    object-fit: cover;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    transition: transform 0.2s;\r\n}\r\n\r\n.ficha-fotos-grid img:hover {\r\n    transform: scale(1.05);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
